export enum ArticleFamilyType {
  PIECE = 'PIECE',
  WEIGHT = 'WEIGHT',
}
